import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import Core from "../Core";
import moment from "moment";

class OfflineLicensesInUseDetailPage extends Component {
  constructor(props) {
    super(props);
    const licenseInUse = props.stores.data.LicensesInUseStore.add();

    this.state = {
      error: null,
      licenseInUse: licenseInUse,
      customerId: props.customerId,
      licenseId: null,
      userId: null,
      sessionId: null
    };

    this.failure = this.failure.bind(this);
    this.succes = this.succes.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
  }

  componentDidMount() {
    const { stores } = this.props;

    if (this.state.customerId) {
      stores.data.LicensesStore.fetchByCustomerId(this.state.customerId);
      stores.data.UsersStore.fetchByCustomerId(this.state.customerId);
    }
  }

  onApplicationChange(e) {
    this.setState({ licenseId: e.target.value });
  }

  onUserChange(e) {
    this.setState({ userId: e.target.value });
  }

  onSessionIdChange(e) {
    this.setState({ sessionId: e.target.value });
  }

  validateValue(value, required = true) {
    let validationState = null;

    if (required && (value === null || value === undefined || value.length === 0)) {
      validationState = "error";
    }

    return validationState;
  }

  onSaveClick() {
    this.setState({ error: null, success: null });

    if (this.state.licenseInUse) {
      let licenseInUse = this.state.licenseInUse;
      licenseInUse.LicenseId = this.state.licenseId;
      licenseInUse.UserId = this.state.userId;
      licenseInUse.SessionId = this.state.sessionId;
      licenseInUse.Offline = true;
      licenseInUse.store.storeModel(licenseInUse, this.succes, this.failure);
    }
  }

  succes(key) {
    if (this.state.customerId) window.location.hash = `#offline-licenses-in-use-list?customerId=${this.state.customerId}`;
  }

  failure(key, error) {
    if (error.response && error.response.headers) {
      this.setState({ error: error.response.headers["x-error-message"] });
    }
  }

  onCancelClick() {
    window.history.back();
  }

  getApplications() {
    const { stores } = this.props;

    const applicationRows = stores.data.LicensesStore.map(license => {
      const licenseType = license.getType();

      const application = stores.data.ApplicationsStore.findById(license.ApplicationId);

      let endDate = "None";
      if (license.EndDate) endDate = moment(license.EndDate).format("L");

      return (
        <option key={license.Id} value={license.Id}>
          {application.Name} ({licenseType}, End:&nbsp;
          {endDate}, Amount: {license.Number})
        </option>
      );
    });
    return applicationRows;
  }

  render() {
    const { stores } = this.props;

    const license = this.state.licenseInUse;
    if (!license) throw new Error("license cannot be null");

    const applicationRows = this.getApplications();

    const userRows = stores.data.UsersStore.map(user => {
      return (
        <option key={user.Id} value={user.Id}>
          {user.Name}
        </option>
      );
    });

    let error = "";
    if (this.state.error) {
      error = (
        <div className="alert alert-danger">
          <span>{this.state.error}</span>
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <h1>Add a new offline license</h1>
          <div className="alert alert-danger">
            <span>
              WARNING: Creating an offline license will lock one license for this application to the selected user! This license can only be set back
              to online when it expires! The license will expire one year after creating the offline license OR when the expiry date of the license is
              reached!
            </span>
          </div>
          {error}
        </div>

        <Form className="well">
          <div className="row">
            <FormGroup className="col-sm-4" validationState={this.validateValue(license.Id, true)}>
              <ControlLabel>Application</ControlLabel>
              <FormControl
                componentClass="select"
                placeholder="select"
                defaultValue={license.Id}
                required={true}
                onChange={this.onApplicationChange.bind(this)}
              >
                <option value="">Select</option>
                {applicationRows}
              </FormControl>
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-sm-4" validationState={this.validateValue(license.UserId, true)}>
              <ControlLabel>User</ControlLabel>
              <FormControl componentClass="select" placeholder="select" required={true} onChange={this.onUserChange.bind(this)}>
                <option value="">Select</option>
                {userRows}
              </FormControl>
            </FormGroup>
          </div>

          <div className="row">
            <FormGroup className="col-sm-4" validationState={this.validateValue(license.SessionId, true)}>
              <ControlLabel>Request code</ControlLabel>
              <FormControl type="text" placeholder="Request code" required={true} onChange={this.onSessionIdChange.bind(this)} />
            </FormGroup>
          </div>

          <div className="row">
            <div className="pull-right">
              <Core.Components.Buttons.Save onClick={this.onSaveClick.bind(this)} />
              <Core.Components.Buttons.Cancel onClick={this.onCancelClick.bind(this)} />
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default inject("stores")(observer(OfflineLicensesInUseDetailPage));



// WEBPACK FOOTER //
// ./src/Pages/OfflineLicensesInUseDetailPage.js